import { render, staticRenderFns } from "./newShareholder.vue?vue&type=template&id=20fc2d52&"
import script from "./newShareholder.vue?vue&type=script&lang=js&"
export * from "./newShareholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports